import {
    constant,
    times
} from 'lodash';

const digitRegex = /[0-9]/;
const twoDigits = times(2, constant(digitRegex));
const threeDigits = times(3, constant(digitRegex));
const fourDigits = times(4, constant(digitRegex));

export type TextMask = Array<string | RegExp>;

const TextMasks = {
    get usSocialSecurityNumberMask(): TextMask {
        return [...threeDigits, '-', ...twoDigits, '-', ...fourDigits];
    },
    get phoneNumberMask(): TextMask {
        return ['(', ...threeDigits, ')', ' ', ...threeDigits, '-', ...fourDigits];
    }
};

export default TextMasks;



// WEBPACK FOOTER //
// ./src/models/text-masks.ts